<template>
  <!-- footer -->
  <footer class="ftco-footer">
    <div class="container">
      <div class="row mb-5">
        <div v-if="textoRodape != ''" class="col-sm-12 col-md">
          <div class="ftco-footer-widget mb-4">
            <router-link to="/" class="logo-rodape"><img src="/images/performance_logo_header.svg" style="width: 200px;" class="img-fluid"></router-link>
            <p>{{ textoRodape[0].itiNome }}</p>
            <p v-html="textoRodape[0].itiResumo1"></p>
            <ul v-if="redesSociais !=''" class="ftco-footer-social list-unstyled mt-2">
              <li v-if="redesSociais[0].itiNome !=''"><a :href="redesSociais[0].itiNome" target="_blank"><span class="fa fa-facebook"></span></a></li>
              <li v-if="redesSociais[0].itiReferencia !=''"><a :href="redesSociais[0].itiReferencia" target="_blank"><span class="fa fa-instagram"></span></a></li>
              <li v-if="redesSociais[0].itiCampoExtra2 !=''"><a :href="redesSociais[0].itiCampoExtra2" target="_blank"><span class="fa fa-linkedin"></span></a></li>
              <li v-if="redesSociais[0].itiCampoExtra1 !=''"><a :href="redesSociais[0].itiCampoExtra1" target="_blank"><span class="fa fa-youtube"></span></a></li>
            </ul>
          </div>
        </div>
        <div class="col-sm-12 col-md">
          <div class="ftco-footer-widget mb-4 ml-md-4">
            <h2 class="ftco-heading-2">Menu</h2>
            <ul class="list-unstyled">
              <li><router-link to="/"><span class="fa fa-chevron-right mr-2"></span>Home</router-link></li>
              <li><router-link to="/empresa"><span class="fa fa-chevron-right mr-2"></span>A Empresa</router-link></li>
              <li><router-link to="/manutencao"><span class="fa fa-chevron-right mr-2"></span>Manutenção</router-link></li>
              <li><router-link to="/blog"><span class="fa fa-chevron-right mr-2"></span>Blog</router-link></li>
              <li><router-link to="/contato"><span class="fa fa-chevron-right mr-2"></span>Contato</router-link></li>
            </ul>
          </div>
        </div>
        <div class="col-sm-12 col-md">
          <div class="ftco-footer-widget mb-4 ml-md-4">
            <h2 class="ftco-heading-2">Soluções</h2>
            <ul class="list-unstyled">
              <li v-for="(solucao, menuIndex) in solucoes" :key="menuIndex">
                <router-link :to="'/SolucaoTecnica/' + solucao.itiId + '/' + solucao.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')"> <span class="fa fa-chevron-right mr-2"></span>{{solucao.itiNome}} </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-sm-12 col-md">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">LGPD</h2>
            <div class="block-23 mb-3">
              <ul class="list-unstyled">
                <li v-for="(menu, menuIndex) in informacoes" :key="menuIndex">
                <router-link :to="'/informacoes/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')"> <span class="fa fa-chevron-right mr-2"></span>{{menu.itiNome}} </router-link>
              </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid px-0 py-5 bg-black">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <p class="mb-0" style="color: rgba(255,255,255,.5);">
              <a href="https://avancedigital.com.br" target="_blank" rel="nofollow noopener">Avance Digital</a>
              <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
            </p>
          </div>
        </div>
      </div>
    </div>

  </footer>
 

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageFooter',
  components: {

  },
  data: () => ({
    textoRodape: [],
    informacoes: [],
    solucoes: [],
    redesSociais: [],

  }),
  methods: {

  },
  created() {
    //texto e logo  
    axios.get('/Process/InsInstitucional/institucional/10/rodape/0/x')
      .then(response => {
        this.textoRodape = response.data;
        console.log('rodapé')
        console.log(this.textoRodape)
      })
      .catch(error => {
        console.error(error);
      });

      // informações LGPD
    axios.get('/Process/InsInstitucional/institucional/18/informacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
      })
      .catch(error => {
        console.error(error);
      });

      //aqui busca lista soluções
    axios.get('/Process/InsInstitucional/institucional/44/listasolucoes/0/x')
      .then(response => {
        this.solucoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('principais soluções')
        //console.log(this.solucoes)
      })
      .catch(error => {
        console.error(error);
      });

      // redes sociais 
    axios.get('/Process/InsInstitucional/institucional/20/redessociais/0/x')
      .then(response => {
        this.redesSociais = response.data;
        //console.log('rodapé')
        //console.log(this.redesSociais)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>